<template>
    <div>
        <MenuMember />
        <PartnerList/>
    </div>
</template>

<script>
    import MenuMember from "@/components/admin/member/menumember/MenuMember.vue";
    import PartnerList from "@/components/admin/member/partner/PartnerList.vue";
    export default {
        name: "Partner",
        components: {
            PartnerList,
            MenuMember
        }
    }
</script>

<style scoped>

</style>
